import React from 'react'
import { GitHub } from '@mui/icons-material'

const Footer: React.FC = () => (
  <footer>
    <h5>Maximilian Crosby</h5>
    <a href="https://github.com/Maximilian118/p10" target="_blank" rel="noopener noreferrer">
      <GitHub/>
    </a>
  </footer>
)

export default Footer